import { Box } from "@mui/material";
import styled from "@mui/styled-engine";

const ConnectSectionRoot = styled(Box)(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  width: "100%",
  height: "100%",
}));

export { ConnectSectionRoot };
